import {
  PropsWithChildren,
  createContext,
  createElement,
  useContext,
  useState,
} from 'react';

type DepartmentSectionsContextType = {
  city: string | null;
  setCity: (city: string | null) => void;
  expressoOnly: boolean;
  onExpressoOnlyChange: (checked: boolean) => void;
};

export const DepartmentSectionsContext =
  createContext<DepartmentSectionsContextType>(
    {} as DepartmentSectionsContextType
  );

export const DepartmentSectionsProvider = ({
  children,
}: PropsWithChildren<{}>) => {
  const [city, setCity] = useState<string | null>(null);
  const [expressoOnly, setExpressoOnly] = useState(false);

  return createElement(
    DepartmentSectionsContext.Provider,
    {
      value: {
        city,
        setCity,
        expressoOnly,
        onExpressoOnlyChange: setExpressoOnly,
      },
    },
    children
  );
};

export const useDepartmentSections = () =>
  useContext(DepartmentSectionsContext);
